module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABxSURBVHgB7ZTdCYAwDIQPJ7kRuv8SjuAoNUIeRGpJrQdi+0Fe2ssd9CfAZFiS1WrFgJauTWjgaMhWG+ohdE32njA8Nd6FRDSPQ2p73SGltS54MXzVvBTSZL7gAxDCIyKEl0wInykh/mjyUSEfdpMfsQMSo0L/1w35WgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xclose.png
// module id = 664
// module chunks = 0